import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    attachChildTableTitle: 'Список заявок на привязку ребенка к родителю',
    attachChildAttachButton: 'Подать заявку',
    attachChild_importFiles: 'Загрузить файлы',
    attachChild_fillIin: 'Введите ИИН ребенка',
    attachChild_chooseParentStatus: 'Кем вы приходитесь ребенку?',
    attachChild_parentStatus_MOTHER: 'Мать',
    attachChild_parentStatus_FATHER: 'Отец',
    attachChild_attachFile: 'Прикрепленные документы:',
    attachChild_attachChild: 'Заявка на привязку ребенка к родителю',

    //column
    attachChildColumn_requesterFIO: 'Фио заявителя',
    attachChildColumn_numberRequest: '№ - номер заявки',
    attachChildColumn_childIin: 'ИИН ребенка',
    attachChildColumn_requesterIIN: 'ИИН заявителя',
    attachChildColumn_status: 'Статус заявки',
    attachChildColumn_date: 'Дата подачи заявки',
    attachChildColumn_status_NEW: 'Новый',
    attachChildColumn_status_APPROVED: 'Принят',
    attachChildColumn_status_DECLINED: 'Отклонен',
    attachChildColumn_parentStatus: 'Статус родителя',
    attachChildColumn_declineReason: 'Введите причину отказа',
    attachChildColumn_reason: 'Причина отказа',

    //modal
    attachChildModal_decline: 'Отклонить',
    attachChildModal_approve: 'Принять',

    attachChildDucks_approveSuccess: 'Заявка принята успешно',
    attachChildDucks_declineSuccess: 'Заявка отклонена успешно',

    //errors
    common_requiredField: 'Обязательное поле для заполнения',
    attachChild_noIin: 'Пожалуйста, введите ИИН ребенка',
    attachChild_badInputIin: 'ИИН должен состоять из 12 цифр',
    attachChild_noFile: 'Пожалуйста, загрузите хотя бы один файл',
    attachChildDucks_makeApplicationFailed: 'Не удалось подать заявку',
    attachChildDucks_loadRequesterFailed: 'Не удалось загрузить список заявок',
    attachChildDucks_downloadFileFailed: 'Не удалось скачать файл',
    attachChildDucks_approveFailed: 'Не удалось принять заявку',
    attachChildDucks_declineFailed: 'Не удалось отклонить заявку'
  },
  kk: {
    attachChildTableTitle: 'Баланы ата-анаға байланыстыру өтініші',
    attachChildAttachButton: 'Өтініш беру',
    attachChild_importFiles: 'Файлдарды жүктеу',
    attachChild_fillIin: 'Бала ИИН енгізіңіз',
    attachChild_chooseParentStatus: 'Сіз балаға кім боласыз?',
    attachChild_parentStatus_MOTHER: 'Анасы',
    attachChild_parentStatus_FATHER: 'Әкесі',
    attachChild_attachFile: 'Қосылған құжаттар:',
    attachChild_attachChild: 'Заявка на привязку ребенка к родителю',

    // column
    attachChildColumn_requesterFIO: 'Өтініш берушінің ТАӘ',
    attachChildColumn_numberRequest: '№ - өтінім нөмірі',
    attachChildColumn_childIin: 'Баланың ЖСН-і',
    attachChildColumn_requesterIIN: 'Өтініш берушінің ЖСН-і',
    attachChildColumn_status: 'Өтініш статусы',
    attachChildColumn_date: 'Өтініш күні',
    attachChildColumn_status_NEW: 'Жаңа',
    attachChildColumn_status_APPROVED: 'Қабылданды',
    attachChildColumn_status_DECLINED: 'Қабылданбады',
    attachChildColumn_parentStatus: 'Ата-ана статусы',
    attachChildColumn_reason: 'Кері қайтару себебі',

    //modal
    attachChildModal_decline: 'Қабылдамау',
    attachChildModal_approve: 'Қабылдау',

    attachChildDucks_approveSuccess: 'Өтінім сәтті қабылданды',
    attachChildDucks_declineSuccess: 'Өтінім сәтті қабылданбады',

    // errors
    common_requiredField: 'Міндетті өріс',
    attachChild_noIin: 'Бала ЖСН енгізіңіз',
    attachChild_badInputIin: 'ЖСН 12 саннан тұруы керек',
    attachChild_noFile: 'Кемінде бір файл жүктеу қажет',
    attachChildDucks_makeApplicationFailed: 'Өтініш жіберілмеді',
    attachChildDucks_loadRequesterFailed: 'Өтініштер тізімін жүктеу сәтсіз аяқталды',
    attachChildDucks_downloadFileFailed: 'Файлды жүктеу сәтсіз аяқталды',
    attachChildDucks_approveFailed: 'Өтінімді қабылдау сәтсіз аяқталды',
    attachChildDucks_declineFailed: 'Өтінімді қабылдамау сәтсіз аяқталды'
  }
});
